import Button from '../button'
import * as S from './styles'
import check from '../../../presentation/assets/images/check-green.gif'

const CompleteModal = () => {
  const handeClick = () => {
    window.location.href = '/?tutorial=add-customer'
  }
  return (
    <S.Wrapper>
      <div className="circle">
        <img src={check} />
      </div>
      <S.Title>Dados atualizados com sucesso!</S.Title>
      <p>Vamos cadastrar seu primeiro paciente</p>
      <Button onClick={() => handeClick()}>Vamos lá</Button>
    </S.Wrapper>
  )
}

export default CompleteModal
